import { render, staticRenderFns } from "./app-header-account-sets.vue?vue&type=template&id=ff5454b8"
import script from "./app-header-account-sets.vue?vue&type=script&lang=js"
export * from "./app-header-account-sets.vue?vue&type=script&lang=js"
import style0 from "./app-header-account-sets.vue?vue&type=style&index=0&id=ff5454b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports